import {
  SEARCH_START,
  SEARCH_END,
  SEARCH_CANCELLED,
  SEARCH_RESET
} from 'constants/actiontypes';

const INITIAL_STATE = {
  loading: false,
  loaded: false,
  images: [],
  page: 1,
  currentPage: 1,
  totalPage: 1,
};

export default (state=INITIAL_STATE, action) => {
  switch(action.type) {
    case SEARCH_START:
      return Object.assign({}, state, {
        loading: true,
        loaded: false
      });
    case SEARCH_END:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        images: action.data.result,
        currentPage: action.data.current_page,
        totalPage: action.data.total_pages,
      });
    case SEARCH_CANCELLED:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
      });
    case SEARCH_RESET:
      return Object.assign({}, state, {
        images: []
      });
  }
  return state;
};



/** WEBPACK FOOTER **
 ** ./reducers/searchlist.js
 **/